<template>
  <svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.358 8.788C2.254 8.04133 2.968 7.42067 3.5 6.926C4.032 6.422 4.47533 5.89933 4.83 5.358C5.18467 4.81667 5.362 4.28467 5.362 3.762C5.362 3.286 5.25 2.91267 5.026 2.642C4.802 2.37133 4.45667 2.236 3.99 2.236C3.52333 2.236 3.164 2.39467 2.912 2.712C2.66 3.02 2.52933 3.44467 2.52 3.986H0.616C0.653333 2.866 0.984667 2.01667 1.61 1.438C2.24467 0.859333 3.04733 0.569999 4.018 0.569999C5.082 0.569999 5.89867 0.854666 6.468 1.424C7.03733 1.984 7.322 2.726 7.322 3.65C7.322 4.378 7.126 5.07333 6.734 5.736C6.342 6.39867 5.894 6.97733 5.39 7.472C4.886 7.95733 4.228 8.54533 3.416 9.236H7.546V10.86H0.63V9.404L1.358 8.788Z"
      fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Two',
};
</script>
